import React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import FooterMap from 'stile-au/src/components/blocks/FooterMap';
import styled from 'styled-components';

import academy from 'stile-shared/assets/images/homepage/academy.png';
import alex from 'stile-shared/assets/images/homepage/alex.jpg';
import filming from 'stile-shared/assets/images/homepage/byron_filming.jpg';
import workbooks from 'stile-shared/assets/images/homepage/byron_workbooks.jpg';
import cham from 'stile-shared/assets/images/homepage/cham.jpg';
import discussions from 'stile-shared/assets/images/homepage/discussions_debates.png';
import engineering from 'stile-shared/assets/images/homepage/engineering_challenges.jpg';
import execs from 'stile-shared/assets/images/homepage/execs.jpg';
import titleBackground from 'stile-shared/assets/images/homepage/homepage_title_background.svg';
import titleBackgroundMobile from 'stile-shared/assets/images/homepage/homepage_title_background_mobile.png';
import jacky from 'stile-shared/assets/images/homepage/jacky.jpg';
import kat from 'stile-shared/assets/images/homepage/kat.jpg';
import mark from 'stile-shared/assets/images/homepage/mark.jpg';
import mel from 'stile-shared/assets/images/homepage/mel.jpg';
import podcast from 'stile-shared/assets/images/homepage/podcast.jpg';
import robotbee from 'stile-shared/assets/images/homepage/robotbee.svg';
import labs from 'stile-shared/assets/images/homepage/robust_labs.png';
import sandpit from 'stile-shared/assets/images/homepage/sandpit.jpg';
import school from 'stile-shared/assets/images/homepage/school_filming.jpg';
import sean from 'stile-shared/assets/images/homepage/sean.jpg';
import stars from 'stile-shared/assets/images/homepage/stars.svg';
import stickyNotes from 'stile-shared/assets/images/homepage/sticky_notes.jpg';
import tShirt from 'stile-shared/assets/images/homepage/t-shirt.jpg';
import tim from 'stile-shared/assets/images/homepage/tim.jpg';
import training from 'stile-shared/assets/images/homepage/training.png';
import underlineMobile from 'stile-shared/assets/images/homepage/underline-mobile.svg';
import underline from 'stile-shared/assets/images/homepage/underline.svg';
import whiskerLeft from 'stile-shared/assets/images/homepage/whisker_left.svg';
import whiskerRight from 'stile-shared/assets/images/homepage/whisker_right.svg';
import workshops from 'stile-shared/assets/images/homepage/workshops.png';
import curriculum from 'stile-shared/assets/videos/curriculum.mp4';
import homepage from 'stile-shared/assets/videos/homepage_AU.mp4';
import lessons from 'stile-shared/assets/videos/lessons.mp4';
import supportTeachers from 'stile-shared/assets/videos/support_teachers.mp4';
import updatedData from 'stile-shared/assets/videos/updated_data.mp4';

import { Button } from 'stile-shared/src/components/2024/common/Button';
import {
  CardGridCard,
  CardGridSection,
} from 'stile-shared/src/components/2024/common/CardGridSection';
import ImageCarousel from 'stile-shared/src/components/2024/common/ImageCarousel';
import WITBFeatureSection from 'stile-shared/src/components/2024/common/Included/WITBFeatureSection/WITBFeatureSection';
import WITBGridItem from 'stile-shared/src/components/2024/common/Included/WITBGridItem/WITBGridItem';
import WITBGridRow from 'stile-shared/src/components/2024/common/Included/WITBGridRow/WITBGridRow';
import TitleMenu from 'stile-shared/src/components/2024/common/Included/WITBTitleMenu/WITBTitleMenu';
import Top from 'stile-shared/src/components/2024/common/Included/WITBTopSection/WITBTopSection';
import ScrollIndicatorContainer from 'stile-shared/src/components/2024/common/ScrollIndicatorContainer/ScrollIndicatorContainer';
import { VideoPlayer } from 'stile-shared/src/components/2024/common/VideoPlayer';
import ReviewsSlider from 'stile-shared/src/components/2024/layout/ReviewsSlider/ReviewsSlider';
import { ScrollJackedComponent } from 'stile-shared/src/components/2024/layout/ScrollJackedSection/ScrollJackedComponent';
import ScrollingSection from 'stile-shared/src/components/2024/layout/ScrollingSection/ScrollingSection';
import { Section } from 'stile-shared/src/components/2024/layout/Section';
import { SideBySideSection } from 'stile-shared/src/components/2024/layout/SideBySideSection';
import TechnologySection from 'stile-shared/src/components/2024/layout/TechnologySection';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

const HomePageLayout = styled(PageLayout)`
  .header-wrapper {
    background-color: var(--white) !important;
    box-shadow: 0px 78px 22px 0px rgba(0, 0, 0, 0), 0px 50px 20px 0px rgba(0, 0, 0, 0),
      0px 28px 17px 0px rgba(0, 0, 0, 0.02), 0px 12px 12px 0px rgba(0, 0, 0, 0.03),
      0px 3px 7px 0px rgba(0, 0, 0, 0.03);
    @media (max-width: 768px) {
      background-color: var(--stile-green-2) !important;
      box-shadow: unset !important;
    }
  }

  .robotbee,
  .stars,
  .whisker-left,
  .whisker-right,
  .underline {
    display: inline-block;
    position: relative;
    &::before {
      bottom: 5px;
      content: '';
      display: block;
      position: absolute;
      background-repeat: no-repeat;
      background-position: top left;
      background-size: cover;
    }
  }
  .whisker-left {
    &::before {
      left: -649px;
      bottom: -124px;
      width: 43px;
      height: 79px;
      z-index: 1;
      background-image: url('${whiskerLeft}');
    }
  }
  .whisker-right::before {
    right: -641px;
    bottom: -146px;
    width: 40px;
    height: 72px;
    z-index: 1;
    background-image: url('${whiskerRight}');
  }
  .robotbee::before {
    left: -70px;
    top: -190px;
    width: 100px;
    height: 140.667px;
    z-index: 1;
    background-image: url('${robotbee}');
  }
  .stars::before {
    left: -25px;
    top: -90px;
    width: 38px;
    height: 50px;
    z-index: -1;
    background-image: url('${stars}');
  }
  .underline::before {
    left: -6px;
    bottom: -3px;
    width: 164.246px;
    height: 23.263px;
    z-index: -1;
    background-image: url('${underline}');
  }

  @media (max-width: 768px) {
    .stars:before,
    .robotbee:before {
      display: none;
    }
    .underline:before {
      background-image: url('${underlineMobile}');
      width: 114.972px;
      height: 16.284px;
    }
  }
`;

const TitleBackground = styled.div`
  position: relative;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: -75%;
    left: 50%;
    transform: translateX(-50%);
    width: 150%;
    max-width: 2800px;
    height: 120%;
    border-radius: 30%;
    background-color: var(--stile-green-2);
    background-image: url(${titleBackground});
    background-position: center bottom;
    background-repeat: no-repeat;
    border-bottom-left-radius: 100%;
    border-bottom-right-radius: 100%;
    z-index: -1;
    @media (max-width: 768px) {
      height: 95%;
      top: -55%;
      border-radius: 30%;
      background-image: url(${titleBackgroundMobile});
    }
  }
`;

const TitleMenuContainer = styled.div`
  display: flex !important;
  flex-direction: column !important;
  padding-bottom: 80px !important;
  h1,
  p {
    color: var(--white);
  }
  p {
    max-width: 663px;
    font-size: 21px;
    font-weight: 500;
    line-height: 26px;
    @media (max-width: 768px) {
      font-size: 19px;
      line-height: 24px;
    }
  }
  h1 {
    max-width: 1100px;
    align-self: center;
    @media (max-width: 1700px) {
      max-width: 917px;
    }
    @media (max-width: 1024px) {
      max-width: 802px;
    }
  }

  .content {
    padding-top: 0px !important;
    @media (max-width: 768px) {
      .grid-layout {
        margin-top: 28px !important;
      }
      padding-top: 0px !important;
    }
  }
  .video {
    overflow: hidden;
    .skeleton.skeleton-video,
    video {
      border-radius: 32px;
    }
    aspect-ratio: 1156/770.328;
    border-radius: 32px;
    box-shadow: 0px 43px 26px 0px rgba(0, 0, 0, 0.04), 0px 19px 19px 0px rgba(0, 0, 0, 0.06),
      0px 5px 11px 0px rgba(65, 44, 44, 0.07);
    border: 2px solid #07fa66;
    margin: 78px auto 89px;
    @media (max-width: 768px) {
      .skeleton.skeleton-video,
      video {
        border-radius: 16px;
      }
      padding-top: 0px !important;
      border-radius: 16px !important;
      border: 0.586px solid #07fa66;
      box-shadow: 0px 12.603px 7.621px 0px rgba(0, 0, 0, 0.04),
        0px 5.569px 5.569px 0px rgba(0, 0, 0, 0.06), 0px 1.466px 3.224px 0px rgba(0, 0, 0, 0.07);
      margin: 40px auto 32px;
    }
  }
  .lock_up {
    max-width: 387px;
    @media (max-width: 768px) {
      max-width: 234px;
    }
  }
  @media (max-width: 768px) {
    padding: 0 25px 40px !important;
    margin: 0 !important;
    > div > div {
      padding-top: calc(32px - 15px) !important;
    }
  }
`;

const HomepageCardGridSection = styled(CardGridSection)`
  .content {
    padding-top: 150px !important;
  }

  @media (max-width: 768px) {
    .content {
      padding-top: 60px !important;
    }
  }
`;

const SideBySideStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 150px;
  padding-top: 150px;
  max-width: 1160px;
  margin: 0 auto;

  > *:last-child {
    margin-bottom: 100px;
  }

  @media (max-width: 1220px) {
    margin: 0 60px;
  }

  @media (max-width: 768px) {
    margin: 0 25px;
    > *:last-child {
      margin-bottom: 0;
    }
  }
  .video {
    min-width: 267px;
    object-fit: cover;
    aspect-ratio: 1;
    box-shadow: 0px 41.958px 25.37px 0px rgba(0, 0, 0, 0.04),
      0px 18.54px 18.54px 0px rgba(0, 0, 0, 0.06), 0px 4.879px 10.733px 0px rgba(0, 0, 0, 0.07);
  }
  @media (max-width: 768px) {
    padding: 60px 0 0;
    gap: 60px;
  }
`;

const FoundersNote = styled<typeof Section>(Section)`
  padding-bottom: 150px;
  h1 {
    margin-top: 10px !important;
  }
  h1,
  h2 {
    grid-column: 2 / span 10 !important;
  }
  .founders-note {
    grid-column: 1 / span 5;
    max-width: 440px;
    aspect-ratio: 1;
  }
  .founders-image {
    grid-column: 7 / span 6;
    border-radius: 37.624px;
    aspect-ratio: 566/700;
  }
  @media (max-width: 768px) {
    padding-bottom: 60px;
    h1 {
      margin-top: 20px !important;
    }
    h2 {
      margin-bottom: 0px !important;
    }
    .content {
      padding-top: 0px !important;
    }
    .founders-note {
      grid-column: 1 / span 12;
      grid-row: 3;
      max-width: none;
    }
    .gatsby-image-wrapper {
      grid-column: 1 / span 12;
      border-radius: 20px !important;
      margin-bottom: 28px;
    }
  }
`;

const TeamSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const TeamSectionContainer = styled.div`
  .content {
    padding-top: 70px !important;
    @media (max-width: 768px) {
      padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .grid-layout {
      margin: 0 !important;
    }
    h2 {
      text-align: left !important;
      margin: 60px 0 60px !important;
      a {
        margin-top: 24px;
      }
    }
  }
`;

const Technology = styled.div`
  padding-bottom: 150px;
  @media (max-width: 768px) {
    padding-bottom: 30px;
  }
`;

export function Head(props: HeadProps) {
  return (
    <SEO
      title="#1 Australian Curriculum for Science | Stile Education"
      description="Stile is the complete science curriculum for Australian schools. High-quality print, digital, and practical resources that students love and teachers can count on."
      slug={props.location.pathname}
    />
  );
}

function HomePage(props: PageProps) {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const images = [
    podcast,
    sean,
    stickyNotes,
    execs,
    tShirt,
    sandpit,
    workbooks,
    kat,
    tim,
    mel,
    jacky,
    alex,
    filming,
    cham,
    school,
    mark,
  ];
  const leftImages = images.slice(0, 8);
  const rightImages = images.slice(8, 16);
  return (
    <HomePageLayout {...props}>
      <TitleBackground>
        <TitleMenuContainer className="content">
          <TitleMenu>
            <Top
              headingStyle="huge"
              title="Australia’s #1 science curriculum"
              description="The core science curriculum for Years 7-10, uniquely customised for your school. Bring the latest real-world, relevant science and engineering problem solving to your classrooms."
            />
            <span className="whisker-left" />
            <span className="whisker-right" />
            <VideoPlayer url={homepage} lazy={false} aspectRatio="1160/772" />
          </TitleMenu>
          <Section
            backgroundColor="--white"
            headingContent={
              <h2>
                <span>
                  A Stile classroom hums with inspired energy — hands up, minds racing, questions
                  flying.
                  <br />
                  <br />
                  Stile was built to help teachers feel powerful, prepared and unstoppable.
                  <br />
                  <br />
                  It's for schools that are...
                  <br />
                  <br />
                  <StaticImage
                    className="lock_up"
                    src="../../../stile-shared/assets/images/homepage/serious_about_science.svg"
                    alt="Serious about Science"
                  />
                </span>
              </h2>
            }
          />
        </TitleMenuContainer>
      </TitleBackground>
      <ReviewsSlider />
      <SideBySideStack>
        <SideBySideSection>
          <div className="image-right">
            <div className="left-text">
              <h1 className="--jumbo">
                From artificial <span className="robotbee" /> intelligence to robot bees
              </h1>
              <span className="--feature_heading">
                Students expect the science they learn at school to be modern and relevant to their
                lives. Stile’s units are built around phenomena students <em>actually</em> want to
                learn about, and students do activities that use science and engineering to solve
                global issues and advance society.
              </span>
            </div>
            <div className="right">
              <VideoPlayer url={lessons} loop={false} />
            </div>
          </div>
        </SideBySideSection>
        <SideBySideSection>
          <div className="image-left">
            <div className="left-img">
              <VideoPlayer url={curriculum} loop={false} />
            </div>
            <div className="right-text">
              <h1 className="--jumbo">
                It’s <span className="underline">your</span> curriculum
              </h1>
              <span className="--feature_heading">
                Every school operates in a unique context, with teachers that have developed
                resources that resonate with the students in the area.
                <br />
                <br /> Stile’s curriculum specialists work with your teachers to tailor our
                curriculum to you. We help you incorporate local phenomena, bring in your own
                resources, and map the scope and sequence to your calendar. <br /> <br /> The
                result? Your very own high quality customised science curriculum.
              </span>
            </div>
          </div>
        </SideBySideSection>
        <SideBySideSection>
          <div className="image-right">
            <div className="left-text">
              <h1 className="--jumbo">
                <span className="stars" />
                Magically updated for you, weekly
              </h1>
              <span className="--feature_heading">
                Science is moving fast. Datasets from 2012 may as well be prehistoric for today’s
                students. Our in-house team has their finger on the pulse, updating datasets and
                science news stories weekly, keeping them fresh for students and educators alike.
              </span>
            </div>
            <div className="right">
              <VideoPlayer url={updatedData} loop={false} />
            </div>
          </div>
        </SideBySideSection>
        <SideBySideSection>
          <div className="image-left">
            <div className="left-img">
              <VideoPlayer url={supportTeachers} loop={false} />
            </div>
            <div className="right-text">
              <h1 className="--jumbo">Support new teachers, empower veterans</h1>
              <span className="--feature_heading">
                Stile provides the support that graduate teachers need, and the flexibility
                experienced teachers deserve.
                <br />
                <br /> For a curriculum implementation to be successful it simply must cater to the
                entire teaching spectrum. That’s why we provide lesson plans, teaching tips, model
                answers, demo videos and more for newer teachers, while also providing experienced
                teachers with the tools to tweak and customise in line with their expertise and
                flair. Teacher agency is essential for student engagement.
              </span>
            </div>
          </div>
        </SideBySideSection>
      </SideBySideStack>
      <HomepageCardGridSection
        heading={<h1 className="--jumbo">Everything in one place</h1>}
        headingButton={
          <Button
            newTab={false}
            href="/what-is-stile/whats-included/"
            label={<span>See what’s included</span>}
          />
        }
      >
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/instructional_material.png"
              alt="Instructional materials"
            />
          }
          title="Instructional materials"
          subtitle="Beautiful, interactive science lessons"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/lab_kits.png"
              alt="Lab kits"
            />
          }
          title="Lab kits"
          subtitle="Kits for vibrant hands-on classrooms"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/revision_workbooks.png"
              alt="Student workbooks"
            />
          }
          title="Student workbooks"
          subtitle="Develop notetaking skills and consolidate learning"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/planning_guides.png"
              alt="Planning guides"
            />
          }
          title="Planning guides"
          subtitle="Help teachers prepare for lessons"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/assessments.png"
              alt="Assessments"
            />
          }
          title="Assessments"
          subtitle="System of diagnostic, formative and summative assessment"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/professional_learning.png"
              alt="Professional learning"
            />
          }
          title="Professional learning"
          subtitle="Practical and evidence-based, delivering real results"
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/powerful_platform.png"
              alt="Powerful platform"
            />
          }
          title="Powerful platform"
          subtitle="Made for dynamic classroom teaching."
        />
        <CardGridCard
          image={
            <StaticImage
              src="../../../stile-shared/assets/images/homepage/responsive_support.png"
              alt="Responsive support"
            />
          }
          title="Responsive support"
          subtitle="Our teachers and engineers are always at the ready."
        />
      </HomepageCardGridSection>
      <FoundersNote
        headingContent={<h1 className="--jumbo">From Stile’s founders</h1>}
        backgroundColor="--stile-grey-1"
        textColor="--stile-grey-8"
      >
        <div className="founders-note">
          <p>
            Young people deserve to graduate from school scientifically literate and ready to tackle
            tomorrow’s problems. Knowledge is power, and the ability to sift fact from fiction, make
            sense of data, and think critically is a life skill that’s more important than ever.
            With STEM careers among the fastest-growing worldwide, students need a strong foundation
            in science and critical thinking—right now.
            <br />
            <br />
            That’s where our brilliant teachers come in. Teachers are the key to shaping the next
            generation of problem-solvers, and we’re here to support them. We’re serious about
            providing the tools they need to excel in the classroom, save time, and deliver
            genuinely engaging learning experiences for every student.
            <br />
            <br />
            Call us passionate, call us meticulous—but we’re sticklers for quality. A clunky,
            unintuitive user experience? Not on our watch. Students and teachers deserve better, and
            the research backs us up: high-quality instructional materials aren’t a
            ‘nice-to-have’—they’re proven to significantly improve student outcomes.
            <br />
            <br />
            That’s what’s driven us for over 10 years, and we’re not slowing down. As a social
            enterprise, we put every dollar back into making our curriculum engaging,
            evidence-based, and ready to teach from day one.
            <br />
            <br />
            Our goal? Simple: deliver world-class science education to every student.
          </p>
          <br />
          <StaticImage
            src="../../../stile-shared/assets/images/homepage/signatures.png"
            alt="signatures"
            style={{ marginTop: '8px' }}
          />
          <br />
          {!isMobile && <br />}
          <strong>Danny, Alan & Byron</strong>
        </div>
        <StaticImage
          className="founders-image"
          src="../../../stile-shared/assets/images/homepage/founders.png"
          alt="Danny, Alan & Byron"
        />
      </FoundersNote>
      <ScrollJackedComponent
        mainHeading="Vibrant, hands-on classrooms"
        subHeadings={['Robust labs', 'Engineering challenges', 'Discussions & debates']}
        paragraphs={[
          'Students learn to observe phenomena, collect and document data, and analyse results to draw conclusions.',
          'Students apply engineering principles to design, prototype, and test solutions for real-world challenges.',
          'Students participate in thoughtful discussions and debates, challenging and defending ideas with logic and evidence.',
        ]}
        images={[
          {
            src: labs,
            alt: 'Robust labs',
          },
          {
            src: engineering,
            alt: 'Engineering challenges',
          },
          {
            src: discussions,
            alt: 'Discussions & debates',
          },
        ]}
      />
      <Technology>
        <TechnologySection />
        <div className="content">
          <WITBFeatureSection>
            <ScrollIndicatorContainer>
              <WITBGridRow>
                <WITBGridItem
                  title="Speed grading with AI"
                  detail="Stile’s in-house prompting engine analyzes student responses and provides draft feedback for teachers to nudge students in the right direction."
                />
                <WITBGridItem
                  title="Edit. Literally. Anything."
                  detail="Rearrange, remove, or tweak any part of your lesson. "
                />
                <WITBGridItem
                  title="Customise lessons"
                  detail="No rigid scripts here. Add the videos, questions, and activities you love, knowing your students will too."
                />
              </WITBGridRow>
              <WITBGridRow>
                <WITBGridItem
                  title="Differentiate lessons"
                  detail="Group students by ability and give them lessons that not only inspire and delight but match their skill levels too."
                />
                <WITBGridItem
                  title="Stimulate discussion"
                  detail="Sometimes, the magic of technology can help even the quietest students find their voice and stimulate rich discussion."
                />
                <WITBGridItem
                  title="Give timely feedback"
                  detail="Feedback is one of the most powerful tools for boosting student outcomes. It’s especially impactful when timely."
                />
              </WITBGridRow>
              <WITBGridRow>
                <WITBGridItem
                  title="Control student screens"
                  detail="Get students back on track and focused on you with just one click, using the Teleport and Pause buttons."
                />
                <WITBGridItem
                  title="Review individual work"
                  detail="Use Stile’s Gradebook to dive deep into each student’s response to every question."
                />
                <WITBGridItem
                  title="Class-wide analytics"
                  detail="Use Stile’s Gradebook to dive deep into each student’s response to every question."
                />
              </WITBGridRow>
            </ScrollIndicatorContainer>
          </WITBFeatureSection>
        </div>
      </Technology>
      <ScrollJackedComponent
        mainHeading="Our expert science teachers team up with yours"
        subHeadings={['Training', 'Workshops', 'Stile Academy']}
        paragraphs={[
          'Video-based modules to learn the basics of Stile at your own pace.',
          'Tailored to your priorities, we come to you and deliver dynamic, practical in-person workshops.',
          'Earn micro-certifications by completing self-paced professional learning, with optional one-on-one coaching from a leading teacher.',
        ]}
        buttonLabel="Read more about Professional Learning"
        buttonHref="/what-is-stile/professional-learning"
        images={[
          {
            src: training,
            alt: 'Robust labs',
          },
          {
            src: workshops,
            alt: 'Engineering challenges',
          },
          {
            src: academy,
            alt: 'Discussions & debates',
          },
        ]}
      />
      <TeamSectionContainer>
        <Section
          backgroundColor="--white"
          headingContent={
            isMobile ? (
              <h2>
                Designed by teachers, scientists, artists, and engineers, supported by a cast of
                experts.
              </h2>
            ) : (
              <h1 className="--jumbo">
                Designed by
                <br />
                teachers,
                <br />
                scientists,
                <br />
                artists,
                <br />
                and engineers,
                <br />
                supported by a
                <br />
                cast of experts.
              </h1>
            )
          }
        ></Section>
        {isMobile ? (
          <>
            <ImageCarousel images={leftImages} />
            <Section
              headingContent={
                <h2>
                  <>
                    For every hour of teaching time we spend
                    <span style={{ color: 'var(--stile-green-3)' }}> 50 hours</span> crafting the
                    perfect resources ready to use in your classrooms.
                  </>
                  <Button
                    label="Our guarantees & principles"
                    newTab={false}
                    href="/who-we-are/our-principles/"
                  />
                </h2>
              }
            ></Section>
            <ImageCarousel images={rightImages} />
          </>
        ) : (
          <TeamSection>
            <ScrollingSection />
          </TeamSection>
        )}
      </TeamSectionContainer>
      <FooterMap />
    </HomePageLayout>
  );
}

export default HomePage;
